import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Row, Col } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

export default class UserView extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			fetch_user: "/user/fetch/:id",
		});

		this.state = {
			user: false,
			roles: [
				{ key: 1, value: "UNAUTHORIZED" },
				{ key: 2, value: "Používateľ prevádzky" },
				{ key: 3, value: "Používateľ klienta" },
				{ key: 4, value: "TOPTEST" },
				{ key: 5, value: "Admin" },
				{ key: 6, value: "Super Admin" }
			]
		};
	}

	componentDidMount() {
		this.fetch();
	}

	fetch() {
		this.api.request({
			route: "fetch_user",
			params: { id: this.props.params.userID },
			success: (response) => {
				this.setState({ user: response });
			}
		});
	}



	render() {
		if (this.state.user === false) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={translate("Profil používateľa") + " " + this.state.user.meta.name + " " + this.state.user.meta.surname} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<table className="table table-striped table-bordered table-hover">
								<tbody>
									<tr>
										<td><b>{translate("E-Mail")}</b></td>
										<td>{this.state.user.email}</td>
									</tr>
									{Object.keys(this.state.user.meta).map(function (key) {
										return (
											<tr key={key}>
												<td><b>{translate(key)}</b></td>
												<td>{this.state.user.meta[key]}</td>
											</tr>
										)
									}.bind(this))}
								</tbody>
							</table>
						</Col>
						<Col lg={6}>

						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/user/UserView.js